export const favoritesEndpoints = {
  CATEGORY: '/docs/categories',
  FILE: '/docs/files',
};
